import React, { useState } from 'react';
import Popover from '@prisjakt/ui-popover';
import {
  H4Text,
  BodySmallText,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';
import T from '@prisjakt/ui-translate';
import { useViewportContext } from '../../../../../components/viewport/context';
import { useEffectOnMount } from '../../../../../hooks/useEffectOnMount';
import * as S from '../styles';

const disclaimerStorageName = 'pj:sortListDisclaimerDismissed';

const PriceListDisclaimer: React.FC = () => {
  const [showDisclaimer, setShowDisclaimer] = useState<boolean | null>(null);
  const { isMobile } = useViewportContext();

  const hideDisclaimer = () => {
    setShowDisclaimer(false);
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(disclaimerStorageName, 'true');
    }
  };

  useEffectOnMount(() => {
    if (
      showDisclaimer === null &&
      typeof window !== 'undefined' &&
      window.localStorage
    ) {
      const storeItem =
        window.localStorage.getItem(disclaimerStorageName) === null;
      setShowDisclaimer(storeItem);
    }
  });

  const popoverProps = popoverSettings(isMobile);

  return showDisclaimer ? (
    <S.DisclaimerWrapper>
      <Popover
        open={showDisclaimer}
        onClose={hideDisclaimer}
        arrow
        {...popoverProps}
      >
        <div />
        <div>
          <H4Text>
            <T domain="product" product="splitlist-disclaimer.title">
              splitlist-disclaimer.title
            </T>
          </H4Text>

          <BodySmallText emphasis={FontEmphasis.MEDIUM}>
            <T domain="product" product="splitlist-disclaimer.description">
              splitlist-disclaimer.description
            </T>
          </BodySmallText>
        </div>
      </Popover>
    </S.DisclaimerWrapper>
  ) : null;
};

const popoverSettings = (isMobile?: boolean) => {
  return isMobile
    ? {
        width: 92,
        offsetX: 5,
        offsetY: 35,
        position: 'bottom-responsive',
        breakpoints: {
          // only has affect in 'bottom-responsive'
          small: {
            point: 420, // breakpoint in window width (px)
            width: 92, // popover width (%)
          },
        },
      }
    : {
        width: 388,
        offsetX: 20,
        offsetY: -62,
        position: 'right',
        arrowOffsetY: 50,
      };
};

export default PriceListDisclaimer;
